import React, { useState, useCallback, useRef } from 'react';

import { ConfirmDialog } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export const useDragAndDropConfirmDialog = (i18n, logger) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showUIBlocker, setShowUIBlocker] = useState(false);
  const targetFolderItemRef = useRef();

  const open = ({ targetFolder }) => {
    setShowConfirmDialog(true);
    targetFolderItemRef.current = targetFolder;
  };

  const render = useCallback((batchMoveApiAsync, onSuccess, onError) => {
    const targetFolderItem = targetFolderItemRef.current;

    const { folderId, folderName } = targetFolderItem || {};

    const title = i18n.getString(_TL_('Are you sure you want to move the selected item(s) to the folder "{{folderName}}"?'), { folderName });

    const batchMoveApiAsyncWrapper = () => {
      setShowUIBlocker(true);
      return batchMoveApiAsync({ destFolderId: folderId })
        .then((result) => {
          onSuccess(result);

          const { hasError } = result || {};
          if (hasError) {
            logger.logTrace('Drag and drop to move items is done with some errors');
          } else {
            logger.logTrace('Drag and drop to move items successfully');
          }
        }).catch((alODataErr) => {
          const { getUXMessage } = alODataErr;
          logger.logError(alODataErr);
          onError(getUXMessage(i18n));
        }).finally(() => {
          setShowUIBlocker(false);
          setShowConfirmDialog(false);
        });
    };

    const onCancel = () => {
      setShowConfirmDialog(false);
    };

    return (<ConfirmDialog
      title={title}
      isDisplayed={showConfirmDialog}
      i18n={i18n}
      confirmString={i18n.getString(_TL_('Yes'))}
      cancelString={i18n.getString(_TL_('No'))}
      onClickConfirm={batchMoveApiAsyncWrapper}
      onClickCancel={onCancel}
      isUiBlocked={showUIBlocker}
      customStyle={{ zIndex: 1100000, background: 'rgba(255, 255, 255, 0.4)', overflowWrap: 'break-word' }}
    />);
  }, [i18n, logger, showConfirmDialog, showUIBlocker]);

  return {
    open,
    render,
  };
};
